import styled, { css } from 'styled-components'
import ripple from '../../../styles/animations/ripple'
import { down } from 'styled-breakpoints'
import fadeIn from '../../../styles/animations/fadeIn'

export const Container = styled.div`
  ${fadeIn};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  ${down('md')} {
    margin-top: 80px;
  }
  position: relative;
`
export const Content = styled.div`
  display: flex;
  width: 100%;
`

export const LineOut = styled.img`
  position: absolute;
  left: 0px;
  top: 0px;
`

export const GridStyles = {
  Content: styled.div`
    ${ripple}
    padding: 15px;
    display: flex;
    max-width: 110px;
    height: 130px;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
  `,
  Folder: styled.img`
    width: 81px;
    height: 68px;
  `,
  Name: styled.div`
    text-align: center;
    font-size: 12px;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.title};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  `,
}

export const PdfPage = {
  Image: styled.div<{ src: string; isList?: boolean }>`
    ${({ src, isList }) =>
      src &&
      css`
        width: 100%;
        height: ${isList ? '350px' : '800px'};
        background-image: url(${src});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      `}
  `,
  Header: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  `,
  Title: styled.div`
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.title};
  `,
  Content: styled.div<{ isList?: boolean }>`
    cursor: pointer;
    ${ripple}
    padding: 15px;
    width: ${({ isList }) => (isList ? '350px' : '100%')};
    ${down('md')} {
      width: 100%;
    }
    heigth: 100%;
  `,
}

export const ListStyles = {
  Content: styled.div`
    gap: 15px;
    padding: 15px;
    display: flex;
    width: 100%;
    flex-direction: column;
  `,
  NameFile: styled.div`
    display: flex;
    width: 50%;
    align-items: center;
    gap: 10px;
    flex-direction: row;
  `,
  Row: styled.div`
    ${ripple}
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-direction: row;
  `,
  Folder: styled.img`
    width: 23px;
    height: 19px;
  `,
  Name: styled.div`
    font-size: 12px;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.title};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  `,
}
export const Message = styled.div`
  font-size: 60px;
  color: #8e8e93;
`
export const LeftContent = styled.div`
  background-color: #efefef;
  width: 350px;
  padding: 0px 20px;
  height: 100%;
  ${down('md')} {
    display: none;
  }
`
export const ContentRight = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  position: relative;
  ${down('md')} {
    width: 100%;
  }
`

export const SendEmailStyles = {
  Content: styled.div`
    padding: 25px 15px;
    border-radius: 30px;
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    background: ${({ theme }) => theme.colors.secondary};
    width: 400px;
  `,
  Label: styled.div`
    color: ${({ theme }) => theme.colors.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  `,
  Row: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    img {
      width: 25px;
      height: 25px;
    }
  `,
  AddButton: styled.img`
    ${ripple}
    cursor: pointer;
    width: 25px;
    height: 25px;
  `,
  Voltar: styled.div`
    color: #efefef;
    font-size: 14.727px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  `,

  Button: styled.div<{ disabled?: boolean }>`
    ${ripple}
    cursor: pointer;
    width: 115px;
    border-radius: 24.545px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ disabled }) =>
      disabled &&
      css`
        cursor: not-allowed;
        pointer-events: none;

        opacity: 60%;
      `}
  `,
  ButtonGreen: styled.div`
    color: #efefef;
    font-size: 14.727px;
    text-align: center;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  `,
  Column: styled.div`
    width: 100%;
    gap: 10px;
    display: flex;
    flex-direction: column;
  `,
  Name: styled.div`
    border-radius: 30px;
    background: #d9d9d9;
    width: 100%;
    color: #646464;
    padding: 8px 15px;
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  `,
  Delete: styled.img`
    ${ripple}
    cursor: pointer;
  `,
}

export const ContentRightBody = styled.div<{ isList?: boolean }>`
  position: relative;
  overflow-y: scroll;
  height: 100%;
  ${({ isList }) => (!isList ? `display: flex;` : `display: block;`)};
  flex-direction: ${({ isList }) => (isList ? `column` : `row`)};
  align-items: flex-start;
  flex-wrap: wrap;
  padding-top: 100px;
  gap: 15px;
  ${down('md')} {
    margin-top: 80px;
  }
`
export const HeaderContent = {
  Content: styled.div`
    display: flex;
    position: fixed;
    z-index: 9;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.secondary};
    padding: 0px 15px;
    width: 100%;
  `,
  ButtonHeader: styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    margin-left: auto;
    img {
      ${ripple}
      cursor: pointer;
      width: 25px;
      height: 25px;
    }
  `,
  HeaderContent: styled.div``,
  ButtonList: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;

    color: ${({ theme }) => theme.colors.title};
  `,
  Columns: styled.div`
    display: flex;
    background-color: #efefef;
    overflow: auto;
    width: 100%;
    padding: 15px;
    padding-top: 0px;
    white-space: nowrap;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
  `,
  ColumnName: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    flex-direction: row;
    img {
      width: 31px;
      height: 31px;
    }
    color: ${({ theme }) => theme.colors.title};
  `,
  BreadCumbs: styled.div`
    flex-direction: row;
    width: 100%;
    display: flex;
    padding: 10px 0px;
    align-items: center;
    overflow: auto;
    white-space: nowrap;
    gap: 5px;
  `,
  BreadName: styled.div``,
}
export const HomeStyles = {
  EditName: styled.div<{ active: boolean }>`
    display: flex;
    flex-direction: row;
    font-size: 12px;
    align-items: center;
    ${({ active }) =>
      active &&
      css`
        border-bottom: 1px solid #646464;
      `}
    img {
      ${ripple}
      cursor: pointer;
      min-width: 25px;
      min-height: 25px;
      max-width: 25px;
      max-height: 25px;
    }
  `,
  Column: styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 35px;
    margin-top: 5px;
    gap: 10px;
  `,
  Row: styled.div`
    ${ripple}
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
  `,
  ContentInner: styled.div`
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  BreadName: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    flex-direction: row;
    color: ${({ theme }) => theme.colors.title};
  `,
  Label: styled.div`
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.title};
  `,
}
